



import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../Images/logo3.png";

import { FaBars, FaTachometerAlt, FaSignOutAlt } from "react-icons/fa";
import { MdClass } from "react-icons/md";

const Studentsidebar = () => {
  const navigate = useNavigate();

  const [hoverItem, setHoverItem] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const openSidebar = () => setShowSidebar(true);
  const closeSidebar = () => setShowSidebar(false);

  const handleLogout = () => {
    localStorage.removeItem("student");
    navigate("/", { replace: true });

    setTimeout(() => {
      window.location.reload();
    }, 50);
  };

  
  const handleNavigate = (path, name) => {
    setHoverItem(name);
    navigate(path);
    closeSidebar();
  };

  const navLinkStyle = ({ isActive }, name) => {
    const isHover = hoverItem === name;
    return {
      backgroundColor:
        isHover || (isActive && !hoverItem) ? "#3D4768" : "transparent",
      color: isHover || (isActive && !hoverItem) ? "#fff" : "#b4b8d1",
      borderRadius: "6px",
      padding: "10px 14px",
      display: "flex",
      alignItems: "center",
      width: "100%",
      textDecoration: "none",
      fontWeight: "500",
      transition: "all 0.25s ease",
      cursor: "pointer",
    };
  };

  return (
    <>
     
      <nav className="navbar d-lg-none px-3" style={{ background: "#272F47" }}>
        <button
          onClick={openSidebar}
          style={{ color: "#fff", border: "none", background: "none" }}
        >
          <FaBars size={22} />
        </button>

        <span className="fw-bold" style={{ color: "#fff", marginLeft: "auto" }}>
          Hello student!
        </span>
      </nav>


      {showSidebar && (
        <>
      
          <div
            onClick={closeSidebar}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              zIndex: 998,
            }}
          />

        
          <div
            style={{
              width: "260px",
              height: "100vh",
              background: "#272F47",
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 999,
              padding: "10px",
            }}
          >
            <div>
              <div className="text-center py-3">
                <img
                  src={logo}
                  alt="logo"
                  className="bg-white rounded-circle"
                  style={{ width: "80px" }}
                />
                <h6 className="mt-2 fw-bold" style={{ color: "#f1f1f5" }}>
                  Scan n Score
                </h6>
              </div>

              <nav className="nav flex-column gap-3">
              
                <div
                  onClick={() =>
                    handleNavigate("/student/dashboard", "dashboard")
                  }
                  onMouseEnter={() => setHoverItem("dashboard")}
                  onMouseLeave={() => setHoverItem(null)}
                  onTouchStart={() => setHoverItem("dashboard")}
                  style={navLinkStyle({ isActive: false }, "dashboard")}
                >
                  <FaTachometerAlt className="me-2" /> Dashboard
                </div>

              
                <div
                  onClick={() =>
                    handleNavigate("/student/exam", "classes")
                  }
                  onMouseEnter={() => setHoverItem("classes")}
                  onMouseLeave={() => setHoverItem(null)}
                  onTouchStart={() => setHoverItem("classes")}
                  style={navLinkStyle({ isActive: false }, "classes")}
                >
                  <MdClass className="me-2" /> Exam
                </div>
              </nav>
            </div>

        
            <div
              style={{
                position: "absolute",
                bottom: "20px",
                left: "10px",
                right: "10px",
                color: "red",
                cursor: "pointer",
                padding: "10px",
                // borderTop: "1px solid rgba(255,255,255,0.2)",
              }}
              onClick={() => setShowLogoutModal(true)}
            >
              <FaSignOutAlt className="me-2" /> Logout
            </div>
          </div>
        </>
      )}

  
      <div
        className="d-none d-lg-flex flex-column"
        style={{
          width: "240px",
          height: "100vh",
          background: "#272F47",
          position: "fixed",
          left: 0,
          top: 0,
        }}
      >
        <div className="text-center py-4">
          <img
            src={logo}
            alt="logo"
            className="bg-white rounded-circle"
            style={{ width: "90px" }}
          />
          <h6 className="mt-2 fw-bold" style={{ color: "#f1f1f5" }}>
            Scan n Score
          </h6>
        </div>

        <nav className="nav flex-column p-3 gap-3">
          <NavLink
            to="/student/dashboard"
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "dashboard")
            }
            onMouseEnter={() => setHoverItem("dashboard")}
            onMouseLeave={() => setHoverItem(null)}
          >
            <FaTachometerAlt className="me-2" /> Dashboard
          </NavLink>

          <NavLink
            to="/student/exam"
            style={({ isActive }) =>
              navLinkStyle({ isActive }, "classes")
            }
            onMouseEnter={() => setHoverItem("classes")}
            onMouseLeave={() => setHoverItem(null)}
          >
            <MdClass className="me-2" /> Exam
          </NavLink>
        </nav>

        <div className="mt-auto p-3">
          <div
            className="text-danger"
            style={{ padding: "10px", cursor: "pointer" }}
            onClick={() => setShowLogoutModal(true)}
          >
            <FaSignOutAlt className="me-2" /> Logout
          </div>
        </div>
      </div>

   
      {showLogoutModal && (
        <>
          <div
            onClick={() => setShowLogoutModal(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 1000,
            }}
          />

          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
              zIndex: 1001,
              width: "300px",
              textAlign: "center",
            }}
          >
            <h5>Confirm Logout</h5>
            <p>Are you sure you want to logout?</p>

            <div className="d-flex justify-content-between mt-3">
              <button
                className="btn btn-secondary"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-danger"
                onClick={() => {
                  setShowLogoutModal(false);
                  setTimeout(() => {
                    handleLogout();
                  }, 100);
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Studentsidebar;